import { translationEngDefault as SkhemataBlogCategories } from '../SkhemataBlogCategories/eng';
import { translationEngDefault as SkhemataBlogFeatured } from '../SkhemataBlogFeatured/eng';
import { translationEngDefault as SkhemataBlogList } from '../SkhemataBlogList/eng';
import { translationEngDefault as SkhemataBlogPost } from '../SkhemataBlogPost/eng';
import { translationEngDefault as SkhemataBlogSearch } from '../SkhemataBlogSearch/eng';
export const translationEngDefault = {
    ...SkhemataBlogCategories,
    ...SkhemataBlogSearch,
    ...SkhemataBlogFeatured,
    ...SkhemataBlogList,
    ...SkhemataBlogPost
};
//# sourceMappingURL=eng.js.map